import React, { useContext } from "react";
import { Card } from "react-bootstrap";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import { COLOR_PRIMARY } from "../../constants/colors";
import SmuTable from "../../utils/smu-table/SmuTable";
import { StoreContext } from "../../store/StoreContext";
import { IconArrowLeft } from "../../icons/Icon";
import { useNavigate } from "react-router-dom";

const SearchTable = () => {
  const navigate = useNavigate();
  const { searchResult, setSearchResult, searching, setSearch } =
    useContext(StoreContext);

  const coluns = [
    {
      name: "Sección",
      selector: (row) => row.SECCION,
      cell: (row) => <div className="cell">{row.SECCION}</div>,
      sortable: true,
    },
    {
      name: "Linea",
      selector: (row) => row.LINEA,
      cell: (row) => <div className="cell">{row.LINEA}</div>,
      sortable: true,
    },
    {
      name: "Categoría",
      selector: (row) => row.DESC_CATEGORIA,
      cell: (row) => <div className="cell">{row.DESC_CATEGORIA}</div>,
      sortable: true,
    },
    {
      name: "SAP",
      selector: (row) => row.ID_COD_SAP,
      cell: (row) => <div className="cell">{row.ID_COD_SAP}</div>,
      sortable: true,
    },
    {
      name: "EAN",
      selector: (row) => row.EAN,
      cell: (row) => <div className="cell">{row.EAN}</div>,
      sortable: true,
    },
    {
      name: "Descripción",
      selector: (row) => row.DESCRIPCION,
      cell: (row) => <div className="cell">{row.DESCRIPCION}</div>,
      sortable: true,
    },
    {
      name: "UMV",
      selector: (row) => row.UNIDAD_VENTA,
      cell: (row) => <div className="cell">{row.UNIDAD_VENTA}</div>,
      sortable: true,
    },
    {
      name: "Precio Modal",
      selector: (row) => row.PRECIO_NORMAL,
      cell: (row) => <div className="cell">{row.PRECIO_NORMAL}</div>,
      sortable: true,
    },
    {
      name: "Factor",
      selector: (row) => row.FACTOR,
      cell: (row) => <div className="cell">{row.FACTOR}</div>,
      sortable: true,
    },
    {
      name: "F. Inicio",
      selector: (row) => row.FECHA_INICIO,
      cell: (row) => <div className="cell">{row.FECHA_INICIO}</div>,
      sortable: true,
    },
    {
      name: "F. Término",
      selector: (row) => row.FECHA_TERMINO,
      cell: (row) => <div className="cell">{row.FECHA_TERMINO}</div>,
      sortable: true,
    },
    {
      name: "Precio Of.",
      selector: (row) => row.PRECIO_OFERTA,
      cell: (row) => <div className="cell">{row.PRECIO_OFERTA}</div>,
      sortable: true,
    },
  ];

  React.useEffect(() => {
    // Avoid clearing searchResult on unmount to prevent data loss in StrictMode remounts
    return () => {};
  }, []);

  const back = () => {
    navigate(-1);
  };

  return (
    <Card className="smu-card">
      <Card.Header className="d-flex py-4">
        <div className="d-flex align-items-center me-auto">
          <SmuBadge color={COLOR_PRIMARY} />
          <span className="fs-5 ms-3 me-auto">
            Tu resultado de búsqueda ha arrojado
            <span style={{ color: COLOR_PRIMARY }} className="mx-1">
              {searchResult.length}
            </span>
            {searchResult.length > 1 ? "promociones" : "promoción"}
          </span>
        </div>
        <div>
          <button
            className="smu-generic-button my-auto py-1 fs-6 px-3 d-flex align-items-center"
            onClick={() => back()}
          >
            <IconArrowLeft /> <span className="ms-2">Atras</span>
          </button>
        </div>
      </Card.Header>
      <Card.Body>
        <SmuTable columns={coluns} data={searchResult} loading={searching} />
      </Card.Body>
    </Card>
  );
};

export default SearchTable;
